<script setup lang="ts">
import { getAppUrl } from '@/lib/helpers'
import { Mousewheel } from 'swiper/modules'
</script>

<template>
  <v-container id="zostan-czescia">
    <div class="d-flex flex-column ga-5">
      <div class="mb-1 text-center">
        <v-chip
          color="gray-300"
          variant="outlined"
          text="Dołącz do nas"
        />
      </div>
      <div class="text-h3 text-center">
        Zostań częścią CSM/online
      </div>
      <div
        class="text-subtitle-1 text-gray-500 font-weight-regular mx-auto text-center"
        :style="{ maxWidth: '550px'}"
      >
        Twoje wsparcie pozwala nam regularnie poszerzać bazę pieśni i tworzyć nowe materiały, które pomagają służbom uwielbienia w lokalnych Kościołach.
      </div>
      <v-container max-width="1100" class="mt-2">
        <swiper
          slides-per-view="auto"
          :space-between="24"
          class="w-100"
          :loop="$vuetify.display.smAndDown"
          :modules="[
            Mousewheel
          ]"
          :mousewheel="{
            forceToAxis: true,
          }"
        >
          <swiper-slide class="h-auto" :style="{ maxWidth: '340px' }">
            <div class="d-flex fill-height">
              <v-card
                color="gray-50"
                variant="flat"
                border
                rounded="xll"
                class="pa-6 border-opacity-100 d-flex flex-column ga-3"
              >
                <div class="text-h4 font-weight-bold text-primary-400">
                  Basic
                </div>
                <div class="text-subtitle-2 mb-4">
                  Przetestuj możliwości CSM/online
                </div>
                <ul class="text-subtitle-3 flex-grow-1">
                  <li>1 użytkownik</li>
                  <li>pełna baza tekstów</li>
                  <li>wybrane tutoriale wideo</li>
                  <li>wybrane opracowania utworów</li>
                </ul>
                <v-spacer />
                <div class="d-flex justify-end">
                  <v-btn
                    :text="$auth.check ? 'Korzystaj' : 'Dołącz'"
                    color="primary-800"
                    variant="flat"
                    rounded="xll"
                    :href="getAppUrl()"
                  />
                </div>
              </v-card>
            </div>
          </swiper-slide>

          <swiper-slide class="h-auto" :style="{ maxWidth: '340px' }">
            <div class="d-flex fill-height">
              <v-card
                color="gray-50"
                variant="flat"
                border
                rounded="xll"
                class="pa-6 border-opacity-100 d-flex flex-column ga-3"
              >
                <div class="text-h4 font-weight-bold text-primary-400">
                  Solo
                </div>
                <div class="text-subtitle-2 mb-4">
                  Rozwijaj umiejętności i wzrastaj w uwielbieniu
                </div>
                <ul class="text-subtitle-3 flex-grow-1">
                  <li>1 użytkownik</li>
                  <li>pełna baza tekstów</li>
                  <li>pełna baza tutoriali wideo</li>
                  <li>pełna baza opracowań utworów</li>
                  <li>strefa inspiracji</li>
                </ul>
                <v-spacer />
                <div class="d-flex justify-end">
                  <v-btn
                    :text="$auth.check ? 'Korzystaj' : 'Dołącz'"
                    color="primary-800"
                    variant="flat"
                    rounded="xll"
                    :href="getAppUrl()"
                  />
                </div>
              </v-card>
            </div>
          </swiper-slide>

          <swiper-slide class="h-auto" :style="{ maxWidth: '340px' }">
            <div class="d-flex fill-height">
              <v-card
                color="gray-50"
                variant="flat"
                border
                rounded="xll"
                class="pa-6 border-opacity-100 d-flex flex-column ga-3"
              >
                <div class="text-h4 font-weight-bold text-primary-400">
                  Team
                </div>
                <div class="text-subtitle-2 mb-4">
                  Twórz zespoły i wspólnie korzystajcie ze sprawdzonych materiałów
                </div>
                <ul class="text-subtitle-3 flex-grow-1">
                  <li>5-100 użytkowników w zespole</li>
                  <li>pełna baza tekstów</li>
                  <li>pełna baza tutoriali wideo</li>
                  <li>pełna baza opracowań utworów</li>
                  <li>strefa inspiracji</li>
                  <li>pliki ProPresenter z tekstami utworów</li>
                  <li>możliwość tworzenia wielu zespołów</li>
                </ul>
                <v-spacer />
                <div class="d-flex justify-end">
                  <v-btn
                    :text="$auth.check ? 'Korzystaj' : 'Dołącz'"
                    color="primary-800"
                    variant="flat"
                    rounded="xll"
                    :href="getAppUrl()"
                  />
                </div>
              </v-card>
            </div>
          </swiper-slide>
        </swiper>
      </v-container>
    </div>
  </v-container>
</template>

<style scoped>
ul {
  list-style: none;
  padding-left: .25rem;
}

ul li {
  position: relative;
  padding-left: 1.75rem;
  padding-bottom: 0.5rem;
  margin-bottom: 0.5rem;
}

ul li::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0.25rem;
  width: 1rem;
  height: 1rem;
  background-color: rgb(var(--v-theme-primary-400));
  mask-image: url("data:image/svg+xml,%3Csvg width='12' height='11' viewBox='0 0 12 11' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M10.7464 0.274437L3.58641 7.18444L1.68641 5.15444C1.33641 4.82444 0.786406 4.80444 0.386406 5.08444C-0.00359413 5.37444 -0.113594 5.88444 0.126406 6.29444L2.37641 9.95444C2.59641 10.2944 2.97641 10.5044 3.40641 10.5044C3.81641 10.5044 4.20641 10.2944 4.42641 9.95444C4.78641 9.48444 11.6564 1.29444 11.6564 1.29444C12.5564 0.374437 11.4664 -0.435563 10.7464 0.264437V0.274437Z' fill='black'/%3E%3C/svg%3E");
  mask-repeat: no-repeat;
  mask-position: center;
  mask-size: contain;
}
</style>

